<template>
  Disb Amount: {{ totalAmount }}
  <span v-if="count > 1">&nbsp;({{ count }} items)</span>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    totalAmount?: string;
    count: number;
  }>(),
  {
    count: 0,
  },
);
</script>
